import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import { dataActions } from "../store/data-slice";
import { toggleActions } from "../store/toggle-slice";
import { screenActions } from "../store/screens-slice";
import { useWindowDimensions } from "../hooks/useWindowDimensions";
import { formatDate } from "../helpers/formatDate";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

import "../components/Element.css";

import { useTranslation } from "react-i18next";

import { SlideDown } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";

const Element = ({ data, tipo = null, handleClass, classes, month }) => {
  const [toggleSelectButton, setToggleSelectButton] = useState(true);
  const [toggleBottomDiv, settoggleBottomDiv] = useState(false);
  const [personsNumber, setPersonsNumber] = useState(1);
  const [t, i18n] = useTranslation("global");
  const { width } = useWindowDimensions();

  const { id, pracod, fecha, horario, plazas, modalidad, level } = data.itm;

  const disableElements = useSelector((state) => state.toggle.disableElements);

  const salidas = useSelector((state) => state.data.salidas);

  const dispatch = useDispatch();

  dispatch(screenActions.setTipo(tipo));

  const recoverSelectedValues = () => {
    if (salidas.length > 0) {
      salidas.forEach((s) => {
        if (s.id == id) {
          setPersonsNumber(s.personas);
          handleClass(s.id, true);
          applyChanges(true, true);
        }
      });
    }
  };

  useEffect(() => {
    recoverSelectedValues();
  }, []);

  const handleSelect = () => {
    dispatch(screenActions.setScrollDivPracticas(`#element_${id}`));
    dispatch(dataActions.elementoSeleccionadoEnPracticas("con_fecha"));
    dispatch(screenActions.setMonthSelected(""));

    handleClass(id, true);
    applyChanges(true, true);
    dispatch(
      dataActions.applyPracticas({
        personas: 1,
        periodo: tipo,
        data: {
          id,
          pracod,
          fecha,
          horario,
          plazas,
          modalidad,
        },
      })
    );
    dispatch(
      dataActions.setSalidas({
        id,
        personas: 1,
        periodo: tipo,
        data: {
          id,
          pracod,
          fecha,
          horario,
          plazas,
          modalidad,
        },
      })
    );
  };

  const handleRemove = () => {
    if (salidas.length == 1) handleClass(-1, false);
    applyChanges(false, false);
    dispatch(dataActions.elementoSeleccionadoEnPracticas(""));
    dispatch(
      dataActions.applyPracticas({
        personas: 1,
        periodo: tipo,
        data: {},
      })
    );
    dispatch(dataActions.removeSalidas(id));
  };

  const applyChanges = (disableClassValue, disableFechaDespuesValue) => {
    setToggleSelectButton(!toggleSelectButton);

    dispatch(toggleActions.disableClass(disableClassValue));
    settoggleBottomDiv(!toggleBottomDiv);
  };

  // 'en'
  let places_string;
  // 'es' y 'cat'
  let places_string2;

  const { language } = i18n;

  if (language == "EN") {
    if (plazas === 1) {
      places_string = `${t("ELEMENT.places.sing")} ${t(
        "ELEMENT.places.remain_s"
      )}`;
    } else {
      places_string2 = `${t("ELEMENT.places.plural")} 
      ${t("ELEMENT.places.remain_p")}`;
    }
  } else {
    if (plazas === 1) {
      places_string = `${t("ELEMENT.places.remain_s")}`;
      places_string2 = `${t("ELEMENT.places.sing")}`;
    } else {
      places_string = `${t("ELEMENT.places.remain_p")}`;
      places_string2 = `${t("ELEMENT.places.plural")}`;
    }
  }

  function formatPlazasQuedan() {
    let plazasQuedanFormated;

    if (width > 370) {
      if (language == "en") {
        plazasQuedanFormated = `${plazas} ${places_string2} ${places_string}`;
      } else {
        plazasQuedanFormated = `${places_string} ${plazas} ${places_string2}`;
      }
    } else {
      if (language == "en") {
        plazasQuedanFormated = `${plazas} ${places_string}`;
      } else {
        plazasQuedanFormated = `${plazas} ${places_string2}`;
      }
    }

    return plazasQuedanFormated;
  }

  return (
    <div id={month}>
      <div
        className={
          disableElements
            ? "element__element element__disable"
            : `element__element${classes}`
        }
        id={`element_${id}`}
      >
        <div className="element__top">
          <div className="element__info">
            <p className="element__modalidad">
              {modalidad} {level && `(${level})`}
            </p>
            <p
              className="element__plazasQuedan"
              style={plazas > 3 ? { color: "green" } : {}}
            >
              {formatPlazasQuedan()}
            </p>

            <p className="element__date">{formatDate(fecha, width, 350)}</p>
            <p className="element__hours">{`${horario[0]} ${
              language == "en" ? "to" : "a"
            } ${horario[1]}`}</p>
          </div>
          <div className="element__selecionarEliminarContainer">
            <div className="element__selectionarEliminar">
              {toggleSelectButton ? (
                <>
                  <p>{t("ELEMENT.button.select")}</p>
                  <button onClick={handleSelect}>
                    <AddCircleIcon style={{ color: "#499BB1", fontSize: 60 }} />
                  </button>
                </>
              ) : (
                <>
                  <p>{t("ELEMENT.button.remove")}</p>
                  <button onClick={handleRemove}>
                    <HighlightOffIcon
                      style={{ color: "#499BB1", fontSize: 60 }}
                    />
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        <SlideDown>
          {toggleBottomDiv && (
            <>
              <div className="element__bottom">
                <div className="element__icons">
                  <div className="element__profileIcon">
                    <PersonOutlineIcon style={{ fontSize: 30 }} />
                  </div>
                  <div className="element__decrement">
                    <button
                      onClick={() => {
                        setPersonsNumber(personsNumber - 1);
                        dispatch(
                          dataActions.updateSalidas({
                            id,
                            personas: personsNumber - 1,
                            periodo: tipo,
                            data: {
                              id,
                              fecha,
                              horario,
                              plazas,
                              modalidad,
                            },
                          })
                        );
                      }}
                      disabled={personsNumber == 1}
                    >
                      <RemoveCircleOutlineIcon style={{ fontSize: 30 }} />
                    </button>
                  </div>
                  <div className="element__counter">{personsNumber}</div>
                  <div className="element__increment">
                    <button
                      onClick={() => {
                        setPersonsNumber(personsNumber + 1);
                        dispatch(
                          dataActions.updateSalidas({
                            id,
                            personas: personsNumber + 1,
                            periodo: tipo,
                            data: {
                              id,
                              fecha,
                              horario,
                              plazas,
                              modalidad,
                            },
                          })
                        );
                      }}
                      disabled={personsNumber == plazas}
                    >
                      <AddCircleOutlineIcon style={{ fontSize: 30 }} />
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </SlideDown>
      </div>
    </div>
  );
};

export default Element;
